import {observer} from "mobx-react-lite";
import React from "react";
import {EventBookingStatus} from "../../../shared/enums/eventBookingStatus";
import EventBooking from "../../../stores/domainStore/pages/models/eventBooking";
import EventBookingsTable from "../eventBookingsTable/eventBookingsTable";
import Tag from "../../atoms/tag/tag";
import {useTranslation} from "react-i18next";
import ResidentData from "../../../stores/domainStore/pages/models/residentData";
import BookingNotes from "../../../stores/domainStore/pages/models/bookingNotes";
import {uniqueId} from "lodash";
import {EventPaidType} from "../../../shared/enums/eventPaidType";
import {useStores} from "../../../stores/useStores";
import {EventBookingSource} from "../../../shared/enums/eventBookingSource";

const EventBookingsWaitlistTable: React.FC = () => {
  const {t} = useTranslation(["translation", "event"]);

  const {
    domainStore: {eventsDomainStore},
    uiStore: {eventsUiStore}
  } = useStores();
  const eventDetails = eventsDomainStore.editableEvent;
  const eventBookings = eventsUiStore.waitlistEventBookings;
  const isEditDisabled =
    eventDetails.releaseDate.date !== null
      ? eventDetails.isPassedBookingDeadline
      : eventDetails.isPassedEndDate;

  const calculateEventBookingData = (): EventBooking[] => {
    if (isEditDisabled) {
      return eventBookings;
    } else {
      const addResidentRow = new EventBooking(
        uniqueId(), // use a unique id to trigger table renders
        eventBookings.length + 1, // i is 0 based, but we must show from 1..n
        EventBookingSource.None,
        EventBookingStatus.Waitlist,
        new ResidentData(),
        new BookingNotes(),
        "personId",
        "personId"
      );
      addResidentRow.isAddResident = true;
      return [...eventBookings, addResidentRow];
    }
  };

  const liveData = calculateEventBookingData();

  return (
    <>
      {!!liveData.length && (
        <EventBookingsTable
          eventBookings={liveData}
          type={EventBookingStatus.Waitlist}
          header={
            <div className="booking-tally" data-testid="waitlist-tally">
              {t("event:titles.waitlisted")}
              {!eventsUiStore.isLoading && (
                <Tag
                  text={eventBookings.length.toString()}
                  type={isEditDisabled ? "light" : "warning"}
                />
              )}
            </div>
          }
          isSortingEnabled={false}
          isPaidEvent={
            eventDetails?.priceDetails?.paidType.text === EventPaidType.fixed
          }
        />
      )}
    </>
  );
};

export default observer(EventBookingsWaitlistTable);
